import { createSlice } from '@reduxjs/toolkit'

export const TrendStore = createSlice({
  name: 'TrendStore',
  initialState: {
    step: '',
    stepHistory: '',
    data: {},
    tabFilter: 'increase'
  },
  reducers: {
    getDetailStock: (state: any, actions) => {
      if (state.step === '' && actions.payload.step === 'code') {
        state.stepHistory = ''
      } else if (state.step === '' && actions.payload.step === 'branch') {
        state.stepHistory = ''
      } else if (state.step === 'code' && actions.payload.step === 'branch') {
        state.stepHistory = ''
      } else if (state.step === 'branch' && actions.payload.step === 'code') {
        state.stepHistory = 'branch'
      } else if (state.step === '' && actions.payload.step === 'code') {
        state.stepHistory = ''
      }
      state.step = actions.payload.step
      state.data = actions.payload.data



      if (actions?.payload?.tabFilter) {
        state.tabFilter = actions.payload.tabFilter
      } else {
        state.tabFilter = state.tabFilter
      }
    },
  }
})

// Action creators are generated for each case reducer function
export const { getDetailStock } = TrendStore.actions

export default TrendStore.reducer